import { StyleSheet } from 'aphrodite';
import { borderColor, brandSecondaryText, charmGray, mention, titles, white } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		background: `linear-gradient(135deg, ${mention} 0%, ${white} 100%)`,
		border: `1px solid ${borderColor}`,
		borderRadius: 8,
		padding: '16px 20px',
		marginTop: 12,
		marginBottom: 10,
		width: '100%',
		boxSizing: 'border-box' as const,
	},
	header: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		gap: 12,
		marginBottom: 8,
	},
	headerLeft: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
	},
	label: {
		fontSize: 13,
		fontWeight: 600,
		color: brandSecondaryText,
	},
	timestamp: {
		fontSize: 11,
		color: charmGray,
	},
	toggleButton: {
		background: 'none',
		border: 'none',
		color: brandSecondaryText,
		fontSize: 12,
		fontWeight: 500,
		cursor: 'pointer',
		padding: '2px 8px',
		borderRadius: 4,
		':hover': {
			background: `${brandSecondaryText}14`,
		},
	},
	loading: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		fontSize: 12,
		color: charmGray,
		padding: '8px 0',
	},
	content: {
		fontSize: 13,
		lineHeight: '1.5',
		color: titles,
	},
});
